import styled from '@emotion/styled';
import { OutlineInputControl } from '__components/Inputs/InputControl';
import Select from '__components/Inputs/Select';
import { ValidatedWholeNumberTextInput } from '__components/Inputs/TextInput/presets/WholeNumber';
import Notice from '__components/Kizen/Notice';

export const StyledScriptControl = styled(OutlineInputControl)`
  position: relative;
  & > button {
    position: absolute;
    top: 33px;
    right: 9px;
    z-index: 1;
    outline: none;
  }
`;

export const StyledBasicRRuleWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  align-items: baseline;
`;

export const StyledNumberInput = styled(ValidatedWholeNumberTextInput)`
  width: fit-content;
  & input {
    width: 60px;
  }
`;

export const StyledSelect = styled(Select)`
  min-width: 174px;
`;

export const StyledDateTimeInputWrapper = styled.div`
  min-width: 280px;
  & .date-component-wrapper.with-timezone-warning {
    margin-bottom: 42px;
  }
`;

export const StyledNotice = styled(Notice)`
  height: 122px;
  margin-bottom: 20px;
`;

export const StyledNoticeList = styled.ul`
  padding: 0;
  margin: 0;
  list-style-position: inside;
  & > li {
    margin-bottom: 8px;
    font-size: 14px;
    font-style: italic;
    &:last-child {
      margin-bottom: 0;
    }
  }
`;
